var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-page__container"},[_c('h4',{staticClass:"loading-page__info"},[_vm._v("Welcome to Freight Protection "+_vm._s(_vm.numberShown))]),_c('AnimatedLogo',{staticClass:"logo",attrs:{"isReadyToStart":_vm.countFinished},on:{"animationFinished":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }